var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-2"},[_c('p',{staticClass:"card-text"},[_c('small',{staticClass:"text-muted"},[_c('router-link',{attrs:{"to":{ name: 'user', params: { username: _vm.comment.user }}}},[_vm._v(_vm._s(_vm.comment.user))]),_vm._v(" "+_vm._s(_vm.date)+" ")],1),_c('br'),_vm._v(" "+_vm._s(_vm.comment.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }